<template>
  <div>
    <!-- 在线阅卷确认弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="no-header-dialog"
      @close="onClose"
    >
      <div class="review-dialog">
        <div class="dialog-content">
          <div class="dialog-description">
            依照《中华人民共和国行政复议法》第四十七条的规定，经行政复议机构同意，现将被申请人提交的书面答复、证据、依据等有关材料供你查阅:
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onCancel">取消</el-button>
          <el-button type="primary" @click="onConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 签名弹窗 -->
    <sing-dialog
      v-if="signShow"
      ref="signDialog"
      :detail-info="computedDetailInfo"
      sign-type="onlineReview"
      :opera="0"
      @signature-submit="onSignatureSubmit"
    />
  </div>
</template>

<script>
import SingDialog from '@/components/singDialog/singDialog.vue'

export default {
  name: 'OnlineReview',
  components: {
    SingDialog
  },
  props: {
    caseOrderNo: {
      type: String,
      default: ''
    },
    signatureName: {
      type: String,
      default: ''
    },
    detailInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      signShow: false
    }
  },
  computed: {
    computedDetailInfo() {
      // 确保 detailInfo 包含 caseInfo 和 caseOrderNo
      const info = {
        caseInfo: {
          caseOrderNo: this.caseOrderNo,
          applicantName: this.signatureName || 
                        (this.detailInfo && this.detailInfo.caseInfo && this.detailInfo.caseInfo.applicantName) ||
                        (JSON.parse(localStorage.getItem('applicantInfo') || '{}').loginName) || ''
        },
        ...this.detailInfo
      }
      return info
    }
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true
    },
    
    // 取消按钮
    onCancel() {
      this.dialogVisible = false
    },
    
    // 确定按钮 - 打开签名弹窗
    onConfirm() {
      // 验证签名人姓名
      const signatureName = this.signatureName || 
                           (this.detailInfo && this.detailInfo.caseInfo && this.detailInfo.caseInfo.applicantName) ||
                           (JSON.parse(localStorage.getItem('applicantInfo') || '{}').loginName) || ''
      
      if (!signatureName) {
        signatureName = ''
      }
      
      // 关闭当前弹窗
      this.dialogVisible = false
      
      // 延迟显示签名组件
      setTimeout(() => {
        this.signShow = true
        this.$nextTick(() => {
          if (this.$refs.signDialog) {
            this.$refs.signDialog.open()
          }
        })
      }, 100)
    },
    
    // 签名提交完成
    onSignatureSubmit(data) {
      console.log('在线阅卷签名完成', data)
      this.signShow = false
      
      // 触发确认事件
      this.$emit('confirm', data)
    },
    
    // 关闭弹窗
    onClose() {
      this.signShow = false
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.signShow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.review-dialog {
  .dialog-content {
    padding: 20px 0;
  }

  .dialog-description {
    font-size: 14px;
    color: #666;
    line-height: 24px;
    margin-bottom: 20px;
    text-align: left;
  }

  .dialog-footer {
    text-align: right;
    text-align: center;
    display: flex;
    justify-content: space-between;
    button {
      width: 180px;
    }
  }
}
</style>

<style lang="scss">
// 全局样式，用于隐藏 dialog header
.no-header-dialog {
  .el-dialog__header {
    display: none !important;
  }
  
  .el-dialog__body {
    padding-top: 20px;
    border-radius: 8px!important;
  }
}
</style>

